const Loader = () => {
  return (
    <div className="loader-component">
      <div className="spinner-border text-primary" id="spinner" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
